var B = Object.defineProperty;
var P = (t, e, n) => e in t ? B(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var k = (t, e, n) => (P(t, typeof e != "symbol" ? e + "" : e, n), n);
import c from "dayjs";
import j from "dayjs/plugin/duration";
import _ from "dayjs/plugin/isToday";
import H from "dayjs/plugin/isTomorrow";
import z from "dayjs/plugin/isYesterday";
import q from "dayjs/plugin/relativeTime";
import V from "dayjs/plugin/weekOfYear";
import G from "bytes";
const Jt = (t, e, n, o) => ({
  type: t,
  verb: e,
  id: n,
  payload: o
}), Yt = (t, e = {}) => ({
  type: t,
  ...e
}), Ft = (t) => Array.from({ length: t }, (e, n) => n), f = (t, e) => {
  const n = new CustomEvent(t, { detail: e });
  document.dispatchEvent(n);
}, Bt = (t, e) => {
  const n = (o) => {
    e(o.detail);
  };
  return document.addEventListener(t, n), () => {
    document.removeEventListener(t, n);
  };
};
let m = null, i = null;
const w = {};
function K(t, e = 1) {
  try {
    if (w[t])
      return;
    m = new Audio(t), m.volume = e, m.play().catch((n) => {
      throw new Error(n);
    }), m.onplay = () => {
      w[t] = !0;
    }, m.onpause = () => {
      w[t] = !1;
    }, m.onended = () => {
      m = null;
    };
  } catch {
  }
}
const Pt = () => {
  K(`${Lt}/music/beep2.mp3`);
};
function jt(t, e = 1, n = !0, o) {
  try {
    if (i) {
      i.volume = e, W();
      return;
    }
    i = new Audio(t), i.volume = e, i.loop = n, i.play().catch((r) => {
      throw new Error(r);
    }), i.ontimeupdate = () => {
      !i || (o && f(o, { ts: i.currentTime }), Q());
    }, i.onplay = () => {
      f("MUSIC_STATUS", { status: "PLAYING" }), w[t] = !0;
    }, i.onpause = () => {
      f("MUSIC_STATUS", { status: "PAUSED" }), w[t] = !1;
    }, i.onended = () => {
      f("MUSIC_STATUS", { status: "STOPPED" }), m = null;
    };
  } catch {
  }
}
function W() {
  i && (i.paused ? i.play() : i.pause());
}
function _t() {
  i && (i.pause(), i.currentTime = 0, i = null);
}
function Ht(t) {
  i ? t >= 0 && t <= i.duration ? i.currentTime = t : console.warn("The specified time is out of range.") : console.warn("Background music is not currently playing.");
}
function Q() {
  if (!!i && !i.loop && i.duration - i.currentTime <= 1 && i.volume > 0) {
    const n = setInterval(() => {
      i && i.volume > 0 ? i.volume = Math.max(
        0,
        i.volume - 0.05
      ) : clearInterval(n);
    }, 50);
  }
}
const O = (t) => new Promise((e) => {
  setTimeout(() => {
    e(null);
  }, t);
}), zt = () => O(1e3);
function M(t, e, n = "application/text") {
  let o = new Blob([e], { type: n }), r = window.URL.createObjectURL(o);
  Z(r, t), window.URL.revokeObjectURL(r);
}
async function qt(t, e) {
  const n = atob(e), o = new Uint8Array(n.length);
  for (let l = 0; l < n.length; l++)
    o[l] = n.charCodeAt(l);
  const r = new Blob([o], { type: "image/png" }), s = URL.createObjectURL(r), a = document.createElement("a");
  a.href = s, a.download = t, document.body.appendChild(a), a.click(), document.body.removeChild(a), URL.revokeObjectURL(s);
}
async function Vt(t, e) {
  try {
    const n = await fetch(e, { mode: "cors" });
    if (!n.ok)
      throw new Error("Network response was not ok");
    const o = await n.blob(), r = URL.createObjectURL(o), s = document.createElement("a");
    s.href = r, s.download = t, document.body.appendChild(s), s.click(), document.body.removeChild(s), URL.revokeObjectURL(r);
  } catch (n) {
    console.error("Image download failed:", n);
  }
}
function Gt(t, e) {
  const n = JSON.stringify(e, null, 4);
  return M(t, n, "application/json");
}
const X = (t) => {
  let e = t;
  return Array.isArray(e) && (e = e.join("| ")), e && String(e).includes(",") && (e = `"${e}"`), e;
};
function Kt(t, e, n) {
  const o = Object.values(e).join(","), r = n.map((a) => Object.keys(e).map((l) => X(a[l])).join(",")), s = [o, ...r].join(`
`);
  return M(t, s, "application/csv");
}
function Wt(t, e) {
  return M(t, e, "application/html");
}
function Z(t, e) {
  let n = document.createElement("a");
  n.download = e, n.href = t, n.click();
}
const Qt = (t) => {
  const e = document.querySelector("canvas");
  if (!e)
    return;
  const n = e.toDataURL("image/png"), o = document.createElement("a");
  o.href = n, o.download = t, o.click();
}, tt = (t, e) => {
  const n = document.createElement("a");
  n.href = t, n.download = e, n.click();
}, Xt = (t) => {
  const e = document.querySelector(t.trim());
  if (!e) {
    console.error(`Container with prefix '${t}' not found.`);
    return;
  }
  const n = e.querySelector(
    "canvas"
  );
  if (!n) {
    console.error("Canvas not found inside the container.");
    return;
  }
  return n.toDataURL("image/png").split(",")[1];
}, et = "canvas", nt = "#video", Zt = async (t = 5e3, e) => {
  const n = document.querySelector(et);
  let o = document.querySelector(nt);
  if (!n)
    throw new Error("Canvas or video element not found");
  o || (o = document.createElement("video"), o.className = "recorder-video", o.id = "recorder-video", document.body.appendChild(o));
  const r = n.captureStream();
  o.srcObject = r, o.play();
  const s = new MediaRecorder(r), a = [];
  s.ondataavailable = (p) => {
    a.push(p.data);
  }, s.start(), console.time("recording"), await O(t), console.timeEnd("recording"), s.stop(), await new Promise((p) => {
    s.onstop = p;
  });
  const l = new Blob(a, { type: "video/webm" }), d = URL.createObjectURL(l);
  return e && tt(d, e), d;
}, te = [
  "#e71d43",
  "#ff0000",
  "#ff3700",
  "#ff6e00",
  "#ffa500",
  "#ffc300",
  "#ffe100",
  "#ffff00",
  "#aad500",
  "#55aa00",
  "#008000",
  "#005555",
  "#002baa",
  "#0000ff",
  "#1900d5",
  "#3200ac",
  "#4b0082",
  "#812ba6",
  "#b857ca",
  "#d03a87"
], ee = [
  "#800000",
  "#9A6324",
  "#808000",
  "#3cb44b",
  "#aaffc3",
  "#42d4f4",
  "#4363d8",
  "#000075",
  "#dcbeff",
  "#ffffff",
  "#ffe119",
  "#f58231",
  "#f032e6",
  "#911eb4",
  "#ffd8b1",
  "#fabed4",
  "#bfef45",
  "#469990",
  "#fffac8",
  "#a9a9a9",
  "#e6194B",
  "#000000"
];
c.extend(j);
c.extend(V);
c.extend(q);
c.extend(_);
c.extend(H);
c.extend(z);
const ot = {
  year: "numeric",
  month: "short",
  day: "numeric"
}, u = (t) => t.toString().padStart(2, "0"), D = {
  normal: (t, e = ot) => new Intl.DateTimeFormat(void 0, e).format(new Date(t)),
  short: (t) => new Intl.DateTimeFormat(void 0, {
    month: "short",
    day: "numeric"
  }).format(new Date(t)),
  db: (t) => c(t).format("YYYY-MM-DD"),
  timeShort: (t) => c(t).format("HH:mm"),
  daysFromNow: (t) => c(t).diff(c(), "day"),
  durationMillis: (t) => t === 0 ? "-" : `${(t / 1e3).toFixed(2)}s`,
  timeAgo: (t) => c(t).fromNow(),
  day: (t) => c(t).format("dddd"),
  stopwatch: (t) => c(t).format("mm:ss"),
  googleCalendar: (t) => c(t).format("YYYYMMDDTHHmmss"),
  weekOfYear: (t) => c(t).week(),
  add: (t, e, n) => c(t).add(e, n).format("YYYY-MM-DD"),
  today: () => c().format("YYYY-MM-DD"),
  isSameDay: (t, e) => {
    const n = c(t), o = c(e);
    return n.isSame(o, "day");
  },
  parse: (t) => {
    const e = c(t);
    return {
      day: e.format("dddd"),
      date: e.format("DD"),
      monthLong: e.format("MMMM"),
      week: e.week(),
      base: e.format("YYYY-MM-DD"),
      time: e.format("HH:mm"),
      title: D.getDateTitle(t),
      isToday: e.isToday(),
      delta: e.diff(c(), "day")
    };
  },
  duration: (t) => c.duration(t, "minutes").humanize(),
  getDateString: (t) => {
    const { day: e, date: n, monthLong: o } = D.parse(t);
    return `${e}, ${n} ${o}`;
  },
  isPast: (t) => c(t).isBefore(c()),
  timeFromNow: (t, e) => {
    const n = c(t).fromNow();
    return e ? `${c(t).format("HH:mm ddd")} | ${n}` : n;
  },
  timeAgoS: (t, e = "Modified") => {
    if (!t)
      return "";
    const n = typeof t == "number" ? t * 1e3 : t, o = c(n);
    return c().diff(o, "day") === 0 ? `${e} at ${o.format("HH:mm")}` : `${e} ${o.fromNow()}`;
  },
  getDateTitle: (t) => {
    const e = c(t), n = c();
    if (e.isToday())
      return "today";
    if (e.isYesterday())
      return "yesterday";
    if (e.isTomorrow())
      return "tomorrow";
    if (e.isSame(n.add(2, "day"), "day"))
      return "day after tomorrow";
    if (e.isSame(n.subtract(2, "day"), "day"))
      return "day before yesterday";
    const o = e.diff(n, "day");
    return o < 0 ? `${Math.abs(o)} days ago` : `${o} days from now`;
  }
}, ne = {
  parts: (t) => {
    const e = c(t);
    return {
      hour: e.hour(),
      hourLz: u(e.hour()),
      minutes: e.minute(),
      minutesLz: u(e.minute()),
      seconds: e.second(),
      secondsLz: u(e.second()),
      millis: e.millisecond(),
      millisLz: u(e.millisecond())
    };
  },
  fromDelta: (t, e = 0) => {
    const n = c().add(t, "minute");
    return `${u(n.hour())}:${u(
      e ? Math.round(n.minute() / e) * e : n.minute()
    )}`;
  },
  fromParts: (t) => {
    try {
      const [e, n] = t.split(":").map(Number);
      return `${u(e != null ? e : 0)}:${u(n != null ? n : 0)}`;
    } catch {
      return t;
    }
  }
};
function oe(t) {
  return new Promise((e) => {
    try {
      if (!t.dataTransfer.items || t.dataTransfer.items.length === 0)
        throw new Error("No items in dataTransfer");
      const n = t.dataTransfer.items[0];
      if (n.kind !== "file")
        throw new Error("Not a file");
      const o = n.getAsFile();
      if (!o)
        throw new Error("No file");
      if (o.type !== "application/json")
        throw new Error("Invalid file type");
      const r = new FileReader();
      r.onload = (s) => {
        var l;
        const a = JSON.parse((l = s.target) == null ? void 0 : l.result);
        if (!a)
          throw new Error("Invalid JSON");
        e(a);
      }, r.readAsText(o);
    } catch (n) {
      console.error("Error dropping file:", n), e(null);
    }
  });
}
const $ = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
  /[xy]/g,
  function(t) {
    let e = Math.random() * 16 | 0;
    return (t === "x" ? e : e & 3 | 8).toString(16);
  }
), re = () => $().substring(0, 8), rt = () => $().substring(0, 4), st = (t) => new Promise((e, n) => {
  const o = new Image();
  o.onload = () => {
    e(o);
  }, o.onerror = (r) => {
    n(r);
  }, o.src = t;
}), se = (t) => Promise.all(t.map((e) => st(e))), at = (t) => {
  if (t == null)
    return !1;
  if (typeof t == "object")
    return !0;
  try {
    return JSON.parse(t), !0;
  } catch {
    return !1;
  }
}, ae = (t) => at(t) ? typeof t == "object" ? JSON.stringify(t, null, 2) : JSON.stringify(JSON.parse(t), null, 2) : String(t), ce = () => window.location.hostname === "localhost" || window.location.hostname === "app.sloyd.ai", ie = async (t, e, n = !1) => {
  var l, d;
  const o = t.split("|"), r = (l = o[0]) != null ? l : "";
  let s = (d = o[1]) != null ? d : "";
  const a = {
    id: rt(),
    source: r,
    timestamp: Date.now(),
    verb: s,
    message: t,
    data: e,
    showData: n
  };
  await O(10), f("sloyd/log", a);
}, le = (t, e) => {
  f("ADHOC_LOG", {
    eventId: t,
    ...e
  });
}, de = (t, e, n) => {
  f("ADHOC_LOG_START", {
    eventId: t,
    statusText: e,
    ...n
  });
}, ue = (t, e, n, o) => {
  f("ADHOC_LOG_END", {
    eventId: t,
    statusText: e,
    result: n,
    ...o
  });
}, me = (t) => t.split(`
`).filter((o) => !o.match(/<[^>]*>?/gm)).join(`
`), ct = (t = 0, e = 1) => Math.random() * (e - t) + t, it = (t = 0, e = 1) => Math.floor(ct(t, e)), fe = (t) => {
  const e = t.length, n = it(0, e);
  return t[n];
}, pe = (t, e, n) => {
  const [o, r] = e, [s, a] = n;
  return Math.round(
    (t - o) * (a - s) / (r - o) + s
  );
}, ye = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
let lt = () => {
  const { pathname: t, search: e = "" } = document.location;
  return {
    pathname: t,
    search: e
  };
};
const ge = (t) => {
  lt = t;
}, g = (t, e) => new Intl.NumberFormat(void 0, e).format(t), we = (t, e = "default") => {
  var o;
  const n = Number(t);
  if (isNaN(n))
    return "0";
  switch (e) {
    case "exponantial":
      if (n === 0)
        return "0";
      let [r, s] = n.toExponential(2).split("e");
      return r = parseFloat(r).toFixed(2), `${r} \xD7 10^${parseInt(s)}`;
    case "currency":
      return g(n, { style: "currency", currency: "USD" });
    case "percent":
      return g(n, {
        style: "percent",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    case "float2":
      return g(n, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    case "bytes":
      return (o = G(n)) != null ? o : "";
    case "duration": {
      const a = Math.floor(n / 60), l = n % 60;
      return `${a}:${l.toString().padStart(2, "0")}`;
    }
    case "normal":
      return g(n);
    case "default":
    default:
      return g(n);
  }
}, he = (t) => t ? Array.isArray(t) ? t : [t] : [], Se = (t) => Array.isArray(t) ? t.length === 0 : Object.keys(t != null ? t : {}).length === 0, xe = (t = [], e = 1, n = 0) => t.reduce((o, r, s) => (o[r.id] = { ...r, index: s + n * (e - 1) }, o), {}), be = (t) => t === null ? "null" : t === void 0 ? "undefined" : Array.isArray(t) ? "array" : typeof t, Te = (t, e = "id") => t.reduce((n, o) => (n[o[e]] = o, n), {}), ve = (t) => Object.keys(t).reduce((e, n) => {
  const o = n;
  return t[o] !== void 0 && (e[o] = t[o]), e;
}, {}), Oe = (t) => {
  if (typeof t == "string")
    try {
      return JSON.parse(t);
    } catch {
      return t;
    }
  return t;
}, dt = (t) => t.includes("-") ? t.replace(/-([a-z])/g, (e) => e[1].toUpperCase()) : ut(t), ut = (t) => t.charAt(0).toLowerCase() + t.slice(1), mt = (t) => t.charAt(0).toUpperCase() + t.slice(1), Me = (t) => t.map((e) => {
  const [n, o] = e.split("|");
  return {
    id: n,
    text: mt(n),
    value: n,
    iconName: o
  };
}), Ee = (t) => {
  let e = Array.isArray(t) ? t : Object.values(t);
  const n = /* @__PURE__ */ new Set();
  e.forEach((r) => {
    const { tags: s = [] } = r;
    s.forEach((a) => n.add(a));
  });
  const o = Array.from(n);
  return o.sort(), o.map((r) => ({
    id: r,
    text: r
  }));
}, Le = (t, e) => {
  const n = [
    {
      id: "today",
      text: "Today",
      max: t.today
    },
    {
      id: "thisWeek",
      text: "This week",
      max: t.week
    },
    {
      id: "thisMonth",
      text: "This month",
      max: t.month
    },
    {
      id: "thisYear",
      text: "This year",
      max: t.year
    }
  ];
  return e && n.unshift({
    id: "lastHour",
    text: "Last hour",
    max: 60
  }), n;
}, Ae = () => {
  var e;
  const t = navigator;
  return (e = t.userAgentData) != null && e.platform ? t.userAgentData.platform.toLowerCase().includes("mac") : t.platform.toLowerCase().includes("mac");
}, Ue = (t, e) => {
  const n = t.match(e);
  return n ? n.slice(1) : [];
}, Ne = (t) => t.split("/"), Ie = (t) => ({
  external: Object.keys(t),
  output: {
    globals: Object.keys(t).reduce((e, n) => {
      const o = n.replace(/[@\/]/g, "-"), r = dt(o);
      return e[n] = r, e;
    }, {})
  }
}), ke = (t, e) => {
  const n = {}, o = /type (\w+) = {([\s\S]+?)}/g;
  let r;
  for (; (r = o.exec(t)) !== null; ) {
    const [, s, a] = r, l = {}, d = [], p = /(\w+)\??:\s*(\w+);(?:\s*\/\/\s*(.+))?/g;
    let b;
    for (; (b = p.exec(a)) !== null; ) {
      const [, N, I, y] = b;
      let F = I.toLowerCase(), T;
      I === "string" && (y == null ? void 0 : y.includes("date")) && (T = "date-time");
      const v = {
        type: F
      };
      T && (v.format = T), y && (v.description = y), l[N] = v, b[0].includes("?") || d.push(N);
    }
    n[s] = {
      $schema: "http://json-schema.org/draft-07/schema#",
      type: "object",
      properties: l,
      required: d.length > 0 ? d : void 0,
      additionalProperties: !1
    };
  }
  return e ? ft(n) : n;
}, ft = (t) => {
  const e = Object.keys(t)[0], n = t[e];
  return {
    name: e,
    description: e,
    schema: n
  };
}, De = (t, e = "asc") => (n = {}, o = {}) => {
  const r = Array.isArray(t) ? t : [t];
  let s = 0;
  for (let a = 0; a < r.length; a++) {
    const l = r[a];
    if (n[l] > o[l]) {
      s = 1;
      break;
    }
    if (n[l] < o[l]) {
      s = -1;
      break;
    }
  }
  return e === "asc" ? s : -s;
};
class R {
  constructor() {
    k(this, "store", {});
  }
  getItem(e) {
    return this.store[e] || null;
  }
  setItem(e, n) {
    this.store[e] = n;
  }
  removeItem(e) {
    delete this.store[e];
  }
  clear() {
    this.store = {};
  }
}
const pt = new R(), yt = new R();
let h;
typeof window > "u" ? h = pt : h = window.localStorage;
const gt = (t) => h.getItem(t), wt = (t, e) => h.setItem(t, e), E = (t) => {
  var e;
  return (e = gt(t)) != null ? e : "";
}, L = (t, e) => {
  wt(t, e);
}, $e = (t, e = !1) => {
  const n = E(t);
  return n ? n === "true" : e;
}, Re = (t, e) => {
  L(t, String(e));
}, Ce = (t, e = 0) => {
  const n = E(t);
  return n ? Number(n) : e;
}, Je = (t, e) => {
  L(t, String(e));
}, C = (t) => {
  const e = E(t);
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}, ht = (t, e) => {
  L(t, JSON.stringify(e));
}, Ye = (t, e) => {
  var o;
  const n = (o = C(t)) != null ? o : {};
  ht(t, { ...n, ...e });
}, St = (t, e) => {
  var o;
  return ((o = C(t)) != null ? o : {})[e];
}, Fe = (t) => St("SETTINGS", t), Be = (t) => {
  h.removeItem(t);
};
let x;
typeof window > "u" ? x = yt : x = window.sessionStorage;
const xt = (t) => x.getItem(t), bt = (t, e) => x.setItem(t, e), A = (t) => {
  var e;
  return (e = xt(t)) != null ? e : "";
}, U = (t, e) => {
  bt(t, e);
}, Tt = (t, e = !1) => {
  const n = A(t);
  return n ? n === "true" : e;
}, vt = (t, e) => {
  U(t, String(e));
}, J = (t) => {
  const e = A(t);
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}, Y = (t, e) => {
  U(t, JSON.stringify(e));
}, Ot = (t, e) => {
  var o;
  const n = (o = J(t)) != null ? o : {};
  Y(t, { ...n, ...e });
}, Pe = {
  getString: A,
  setString: U,
  getBoolean: Tt,
  setBoolean: vt,
  getJson: J,
  setJson: Y,
  patchJson: Ot
}, je = (t = {}, e) => {
  const n = "https://storage.googleapis.com/textures-normalize";
  if (!t)
    return null;
  const { id: o } = t, r = o.replace("M-", "T-").replace(/a$/, ""), s = {
    ...t,
    tint: "#ffffff",
    texture: {
      albedoMapUrl: "",
      aoMapUrl: "",
      displacementMapUrl: "",
      normalMapUrl: "",
      roughnessMapUrl: ""
    }
  }, { activeMaps: a } = s;
  for (let l of Object.keys(a != null ? a : {})) {
    if (!a[l])
      continue;
    const p = `${l}MapUrl`;
    s.texture[p] = `${n}/${r}/maps/${e}/${l}.png`;
  }
  return s;
}, _e = (t, e) => new Promise((n, o) => {
  const r = new FileReader();
  r.onload = (s) => {
    var l;
    const a = (l = s.target) == null ? void 0 : l.result;
    if (!a) {
      o(new Error("Failed to read file"));
      return;
    }
    e || n(a);
    try {
      const d = JSON.parse(a);
      n(d);
    } catch {
      o(new Error("Failed to parse JSON"));
      return;
    }
  }, r.readAsText(t);
}), Mt = "1.0.12";
let He = Mt;
const ze = () => new Date().getTime(), S = "https://storage.googleapis.com/sloyd-assets", Et = "https://storage.googleapis.com/sloyd-assets", Lt = S + "/media", qe = S + "/db", Ve = S + "/source", Ge = S + "/source-output", Ke = (t, e) => (e ? S : Et) + "/sections/" + t;
export {
  Jt as $a,
  Yt as $ac,
  Et as ROOT,
  qe as ROOT_DB,
  S as ROOT_DIRECT,
  Lt as ROOT_MEDIA,
  Ge as ROOT_OUTPUT,
  Ke as ROOT_SECTION,
  Ve as ROOT_SOURCE,
  He as VERSION,
  Bt as addListener,
  Ft as arr,
  Te as arrayToObject,
  Me as arrayToOptions,
  Pt as beep,
  pe as changeRange,
  Be as clearJson,
  D as d,
  O as delay,
  ee as distinctColors,
  Qt as downloadCanvas,
  Kt as downloadCsv,
  Wt as downloadHtml,
  Vt as downloadImage,
  qt as downloadImageBase64,
  Gt as downloadJson,
  M as downloadText,
  tt as downloadUrl,
  Ie as externals,
  Q as fadeOut,
  ke as generateJsonSchema,
  $e as getBoolean,
  Xt as getCanvasBase64,
  C as getJson,
  lt as getNavLocation,
  Ce as getNumber,
  E as getString,
  be as getVariableType,
  $ as guid,
  rt as guid4,
  re as guid8,
  oe as handleDrop,
  ge as initGetNavLocation,
  f as invokeEvent,
  Se as isEmpty,
  at as isJson,
  ce as isLocalhost,
  Ae as isMac,
  ye as isMobile,
  Ee as itemsTagsToOptions,
  xe as itemsToObject,
  ie as l,
  st as loadImage,
  se as loadImages,
  le as log,
  ue as logEnd,
  de as logStart,
  we as numeric,
  Le as optionsPeriod,
  je as parseTexturedMaterial,
  Ye as patchJson,
  jt as playBackgroundMusic,
  K as playSfx,
  Fe as prefs,
  ft as prepareSchema,
  ae as prettyJson,
  te as rainbowColors,
  ct as random,
  fe as randomArr,
  it as randomInt,
  _e as readFile,
  Zt as recordCanvasVideo,
  Ue as reg,
  Ne as regPath,
  me as removeHtmlFromMarkdown,
  ve as removeUndefined,
  X as sanitizeValueForCsv,
  zt as second,
  Pe as session,
  Ht as setBackgroundMusicPosition,
  Re as setBoolean,
  ht as setJson,
  Je as setNumber,
  L as setString,
  De as sortBy,
  _t as stopBackgroundMusic,
  ne as t,
  he as toArray,
  Oe as toJson,
  W as toggleBackgroundMusic,
  ze as ts,
  St as valJson
};
